import Step from '../../constants/Step'
import { IColumnFactory } from '../../entities/column/Column'
import { parseIsoDate } from '../../utils/parse-date'
import castListItems from '../castListItems'
import { ICycleResponse, transformCycle } from '../cycle/CycleTransformer'

export interface IColumnResponse {
  'column_id':        number // 1,
  'name':             string // "Incoming",
  'date':             string // "2026-04-07",
  'number_of_orders': number // 2,
  'cycles':           ICycleResponse[]
  'number_products':  number
}

export const transformColumn = (column: IColumnResponse, index: number) : IColumnFactory => {
  return {
    date: parseIsoDate(column.date),
    name: column.name,
    cycles: castListItems(column.cycles, transformCycle),
    step: castStep(index),
    productsCount: column.number_products,
  }
}

const castStep = (step: number): Step => {
  switch(step) {
    case 0: return Step.INCOMING
    case 1: return Step.IN_PROGRESS
    case 2: return Step.READY
    default: throw new Error(`Undefined step number: ${step}`)
  }
}
